/* Loads agent directory data and allows a failed request to be retried; geocoding comes from ./geocode. */
import { agent } from '../api';
let agents;

export { getGeoCode, geocodePlace } from './geocode';

export async function getAllAgents() {
  if (!agents) {
    agents = agent.getAllAgents().catch(error => {
      agents = undefined;
      throw error;
    });
  }
  return agents;
}
